var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.34474 21.1702C2.09086 21.4241 1.90622 21.7241 1.79082 22.0588L0.129057 26.9402C-0.482564 28.7405 1.22536 30.4715 3.0256 29.8829L7.9532 28.2673C8.2994 28.1519 8.62252 27.9557 8.8764 27.7019L22.0667 14.4539L15.535 7.91071L2.34474 21.1702ZM15.5387 12.1608L4.57882 23.1782L3.41453 26.5983L6.86966 25.4654L17.8305 14.4567L15.5387 12.1608Z",
    fill: "#3D0E6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3369 3.97554L26.0364 0.675092C25.1363 -0.225031 23.6707 -0.225031 22.7706 0.675092L17.843 5.60268L24.4093 12.169L29.3369 7.24137C30.237 6.34125 30.237 4.87566 29.3369 3.97554Z",
    fill: "#FFB6BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEdit);
export default __webpack_public_path__ + "static/media/ic_edit.9909bb973e14d14909a88fe77658f670.svg";
export { ForwardRef as ReactComponent };